/* eslint-disable @typescript-eslint/no-unused-expressions */
import network from '../../utils/network';

interface getSettingsParams {
  limit?: number;
  afterCursor?: string;
  beforeCursor?: string;
}

interface updateSettingParams {
  value: string;
  key: string;
}

export const getSettings = async ({ limit, afterCursor, beforeCursor }: getSettingsParams) => {
  let params: { [key: string]: any } = {};
  params.limit = limit;

  afterCursor ? (params.afterCursor = afterCursor) : '';
  beforeCursor ? (params.beforeCursor = beforeCursor) : '';

  const response = await network.get({
    path: `/settings`,
    options: {
      params,
    },
  });
  return response?.data;
};

export const updateSettings = async (data: updateSettingParams) => {
  const response = await network.patch(`/settings/${data.key}`, data);

  return response?.data;
};
